import { createStore } from 'vuex'

export default createStore({
  state: {
    tenants:{},
    tableConfig: {
      loading: false,
      tableData: []
    },
    exportLoading: 0,
    exportLoadingText: '',
    publicObj: {},
    questionObj: {}
  },
  getters: {
  },
  mutations: {
  },
  actions: {
  },
  modules: {
  }
})
